import { MouseEvent, useCallback, useEffect, useState } from 'react';

export const useMenu = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [menuPosition, setMenuPosition] = useState<{ left: number; top: number } | undefined>();

    const handleMenuClicked = (evt: MouseEvent<HTMLLIElement | HTMLButtonElement>): void => {
        if (
            document?.readyState === 'complete' &&
            document?.visibilityState === 'visible' &&
            evt?.currentTarget
        ) {
            const rect = evt.currentTarget.getBoundingClientRect();
            setMenuPosition({ left: rect.left, top: rect.bottom + 10 });
            setMenuOpen(!menuOpen);
        }
    };

    const handleMenuClose = useCallback(() => {
        setMenuOpen(false);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: Event) => {
            if (menuOpen && !(event.target as Element).closest('.lang-switcher-wrapper')) {
                handleMenuClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuOpen, handleMenuClose]);

    return { menuOpen, menuPosition, handleMenuClicked, handleMenuClose };
};
